export const tr = {
    'empty-search-result-details': 'Sorguyu kontrol edin veya kısaltmayı deneyin',
    'empty-search-result-title': 'Sonuç bulunamadı',
    'no-variants': 'Seçenek yok',
    search: 'Arama'
};
